import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=ba95fea8&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=ts&"
export * from "./Suspension.vue?vue&type=script&lang=ts&"
import style0 from "./Suspension.vue?vue&type=style&index=0&id=ba95fea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba95fea8",
  null
  
)

export default component.exports